/* import __COLOCATED_TEMPLATE__ from './add-conversation-topic.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();